import { useState } from "react";
import { IconChevronDown } from "@tabler/icons-react";
import { cn } from "#utils";

function Tabs({ tabs }) {
  const [state, setState] = useState(0);
  return (
    <div>
      <div className="grid grid-cols-1 sm:hidden">
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          aria-label="Select a tab"
          onChange={(e) => setState(e.target.value)}
          className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-white/5 dark:text-gray-100 dark:outline-white/10 dark:*:bg-gray-800 dark:focus:outline-primary"
        >
          {tabs.map((tab, index) => (
            <option value={index} key={tab.key}>
              {tab.name}
            </option>
          ))}
        </select>
        <IconChevronDown
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500 dark:fill-gray-400"
        />
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200 dark:border-white/10">
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {tabs.map((tab, index) => (
              <button
                key={tab.name}
                onClick={() => setState(index)}
                aria-current={index === state ? "page" : undefined}
                className={cn(
                  index === state
                    ? "border-primary text-primary dark:border-primary dark:text-primary"
                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:border-white/20 dark:hover:text-gray-200",
                  "border-b-2 px-1 py-4 text-sm font-medium whitespace-nowrap",
                )}
              >
                {tab.name}
              </button>
            ))}
          </nav>
        </div>
      </div>
      <div>{tabs[state].component}</div>
    </div>
  );
}
export default Tabs;
